import axios from 'axios'

const DEFAULT_HEADERS = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-TOKEN': window.csrfToken,
  'Accept': 'application/json'
}

const validStatuses = [
  200, 201, 202, 203, 204,
  300, 301, 302, 303, 304
]

function getHeaders (multipart = false) {
  return multipart ? {} : DEFAULT_HEADERS
}

const checkResponse = function (response) {
  if (validStatuses.includes(response.status)) {
    if ('error' in response) {
      vm.$notifyError(response.data.message)
    } else if (response.data.message) {
      vm.$notifySuccess(response.data.message)
    }
    // return Promise.resolve(response.data)
  }

  // If not authorized
  // and redirect to login page ?
  if (response.status === 401) {
    return Promise.reject(new Error('USER_ANONYMOUS'))
  }
}

export function checkError (error) {
  if (typeof error !== 'object' || !('response' in error)) {
    return
  }
  if (error.response) {
    if ('showInMessages' in error.response.data && error.response.data.showInMessages === false) {
      return
    }
    if (error.response.status !== 422) {
      vm.$notifyError(error.response.data.message)
    }

    if (error.response.status === 429) {
      vm.$notifyError('Too Many Attempts.')
    }

    if (error.response.status === 403) {
      console.error('403: ' + error.request.responseURL)
      vm.$notifyError('You don\'t have right to this resource!')
    }

    if (error.response.status !== 422) {
      vm.$notifyError(error.response.data.message)
    }
  } else if (error.request) {
    console.log('Request error:')
    console.log(error.request)
  } else {
    console.log('Error', error.message)
  }

}

export const esc = encodeURIComponent

export function qs (params) {
  return (
    Object
      .keys(params)
      .map(k => esc(k) + '=' + esc(params[k]))
      .join('&')
  )
}

const sendRequest = function (method, uri, data, config) {
  return new Promise((resolve, reject) => {
    axios[method](uri, JSON.parse(JSON.stringify(data)), config)
      .then(response => {
        checkResponse(response)
        resolve(response.data)
      })
      .catch(errors => {
        checkError(errors)

        reject(errors.response)
      })
  })
}

export function postRequest (uri, data) {
  return sendRequest('post', uri, data, {
    headers: getHeaders()
  })
}

export function postMultipartRequest (uri, data) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: uri,
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(response => {
        checkResponse(response)
        resolve(response.data)
      })
      .catch(errors => {
        checkError(errors)

        if ('response' in errors) {
          reject(errors.response)
        }
        if ('error' in errors) {
          reject(errors.error)
        }
      })
  })
  //
  // return sendRequest('post', uri, data, {
  //   headers: getHeaders(true)
  // })
}

export function putRequest (uri, data = {}) {
  return sendRequest('put', uri, data, {
    headers: getHeaders()
  })
}

export function patchRequest (uri, data = {}) {
  return sendRequest('patch', uri, data, {
    headers: getHeaders()
  })
}

export function deleteRequest (uri, data = {}) {
  return sendRequest('delete', uri, data, {
    headers: getHeaders()
  })
}

export function getRequest (uri, data = {}) {
  if (Object.keys(data).length > 0) {
    uri = `${uri}?${qs(data)}`
  }

  return sendRequest('get', uri, data, {
    headers: getHeaders()
  })
}

export function downloadRequest (uri, filename, data = {}) {
  if (Object.keys(data).length > 0) {
    uri = `${uri}?${qs(data)}`
  }

  return new Promise((resolve, reject) => {
    axios.get(uri, {
      responseType: 'blob',
      headers: getHeaders()
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    })
      .catch(errors => {
        checkError(errors)

        reject(errors.response)
      })
  })
}

export function uploadRequest (uri, data) {
  return fetch(uri, {
    headers: getHeaders(true),
    cors: true,
    method: 'POST',
    body: data
  })
}

// Means endpoint
export function e (uri) {
  return BASE_URL + uri
}

export { checkResponse }




// WEBPACK FOOTER //
// ./resources/js/shared/utils/http.js